import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
// import App from '@/App.vue'
import i18n from '../i18n'

import Home from '@/views/Home'
import Story from '@/views/Story'
import Layout from '@/views/Layout'
import Outro from '@/views/Outro'

Vue.use(Router)
Vue.use(Meta)

let router = new Router({
  base: "/specials/srebrenica/timeline/",
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/:locale',
      component: Layout,
      beforeEnter: (to, from, next) => {
        const locale = to.params.locale;
        const supported_locales = process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(',');
        if (!supported_locales.includes(locale)) return next('bhs');
        if (i18n.locale !== locale) {
          i18n.locale = locale;
        }
        return next()
      },
      children: [{
          path: '',
          name: 'home',
          component: Home
        },
        {
          path: 'story',
          name: 'story',
          component: Story
        },
        {
          path: 'outro',
          name: 'outro',
          component: Outro
        }
      ]
    },
    {
      path: '*',
      redirect() {
        return process.env.VUE_APP_I18N_LOCALE;
      }
    }
  ]
})

export default router